<template>
    <tr :class="`${isEditRequested ? 'edit-row' : ''}`">
        <td>
            <EmptyTextHandler :text="statusItem.Branch"></EmptyTextHandler>
        </td>
        <td>
            <EmptyTextHandler :text="statusItem.Team"></EmptyTextHandler>
        </td>
        <td>
            <a href="javascript:void(0);" @click="handlePatientNameClick(statusItem)">
                <EmptyTextHandler :text="statusItem.PatientFirstName"></EmptyTextHandler>
            </a>
        </td>
        <td>
            <a href="javascript:void(0);" @click="handlePatientNameClick(statusItem)">
                <EmptyTextHandler :text="statusItem.PatientLastName"></EmptyTextHandler>
            </a>
        </td>
        <td>
            <EmptyTextHandler :text="statusItem.Mrn"></EmptyTextHandler>
        </td>
        <td>
            <EmptyTextHandler :text="getStatusName"></EmptyTextHandler>
        </td>
        <td v-if="statusItem.Task">
            <EmptyTextHandler :text="statusItem.Task"></EmptyTextHandler>
        </td>
        <td v-else>
            <button class="btn btn-sm btn-primary" @click="addTask(statusItem.PatientId)">Add Task</button>
        </td>
        <td>
            <EmptyTextHandler :text="statusItem.TaskType"></EmptyTextHandler>
        </td>
        <td>
            <EmptyTextHandler :text="getTaskStatusName"></EmptyTextHandler>
        </td>
        <td>
            <EmptyTextHandler :text="formatDate(statusItem.VisitDate)"></EmptyTextHandler>
        </td>
        <td>
            <EmptyTextHandler :text="formatDate(statusItem.AdmissionDate)"></EmptyTextHandler>
        </td>
        <td>
            <EmptyTextHandler :text="getDaysRemaining" exceptionMessage="Not Applicable"></EmptyTextHandler>
        </td>
    </tr>
    <tr class="edit-row" v-if="isEditRequested">
        <td :colspan="columns" class="p-3" v-if="!isFrequencyWarningRequested">
            <FormSection
                :full-height="false"
                title="Employee Scheduler"
                :application-id="application"
                :show-product-pill="true"
            >
                <template #content>
                    <section class="p-5 d-flex flex-column text-center text-primary" v-if="isLoading">
                        <i class="fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite"></i>
                        <span class="mt-1 big-text">
                            <b>Loading...</b>
                        </span>
                    </section>
                    <section class="task-details" v-else>
                        <div class="container row m-0 p-1">
                            <div class="form-group col-6 mt-2">
                                <label for="repeat"> Repeat </label>
                                <select id="repeat" class="form-select" v-model="newTaskRepeat">
                                    <option v-for="[key, value] in enumToMap(tasks)" :key="key" :value="value.value">
                                        {{ value.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group col-6 mt-2">
                                <label for="date-to"> Date </label><span class="text-danger">*</span>
                                <i
                                    class="fw-normal ms-1"
                                    v-tooltip="{ title: `Current Benefit Period` }"
                                    v-if="patient"
                                >
                                    <span
                                        v-if="
                                            (patient.benefitPeriodStartDate ||
                                                patient.transferBenefitPeriodStartDate) &&
                                            patient.benefitPeriodEndDate
                                        "
                                    >
                                        <span>(Current Benefit Period: </span>
                                        <strong v-if="patient.isTransfer">{{
                                            formatDate(patient.transferBenefitPeriodStartDate)
                                        }}</strong>
                                        <strong v-else>{{ formatDate(patient.benefitPeriodStartDate) }}</strong>
                                        <span class="mx-1">-</span>
                                        <strong>{{ formatDate(patient.benefitPeriodEndDate) }})</strong>
                                    </span>
                                    <span v-else>
                                        <strong v-if="isPatientPending">(Current Benefit Period: Pending)</strong>
                                        <span v-else> No Benefit Period Found </span>
                                    </span>
                                </i>
                                <DatePicker :getDate="changeNewTaskSingleDate" v-if="newTaskRepeat == 0">
                                    <div class="input-group date datepickerInput">
                                        <input
                                            name="newTaskSingleDate"
                                            type="text"
                                            class="form-control"
                                            placeholder="MM/DD/YYYY"
                                            :value="formatDateInput(newTaskSingleDate)"
                                        />
                                        <div class="input-group-addon input-group-append">
                                            <div class="input-group-text">
                                                <i class="fa fa-calendar"></i>
                                            </div>
                                        </div>
                                    </div>
                                </DatePicker>
                                <DateRangePicker
                                    v-if="newTaskRepeat == 1 || newTaskRepeat == 2 || newTaskRepeat == 4"
                                    :options="newTaskRangePickerOptions"
                                >
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="MM/DD/YYYY"
                                        name="daterange"
                                        v-model="newTaskDateRange"
                                        @change="setNewTaskDateRange"
                                    />
                                </DateRangePicker>
                                <MultiDatePicker
                                    v-if="newTaskRepeat == 3"
                                    :result="newTaskFlexDates"
                                    v-on:updateResult="updatenewTaskFlexDates"
                                >
                                    <input class="form-control" placeholder="MM/DD/YYYY" />
                                </MultiDatePicker>
                            </div>
                            <div class="form-group col-6 mt-2">
                                <label for="task"> Task </label><span class="text-danger">*</span>
                                <TypeaheadInput
                                    :getData="availableTasksFilter"
                                    :value="taskList"
                                    v-on:valueChanged="changeTaskList"
                                    placeholder="Type to Filter Task"
                                    :disabled="!isDateSelected"
                                    :show-all-by-default="true"
                                    :open-on-focus="true"
                                    :must-select-value="true"
                                    ref="typeAheadRefTask"
                                />
                            </div>
                            <div class="form-group col-6 mt-2">
                                <label for="employee"> Employee </label>
                                <TypeaheadInput
                                    :getData="employeeListFilter"
                                    :value="scheduleEmployeeId"
                                    v-on:valueChanged="changeScheduleEmployeeId"
                                    placeholder="Type to Search Employee"
                                    :show-all-by-default="true"
                                    :disabled="!isDateSelected || !isTaskSelected"
                                    ref="typeAheadRefEmp"
                                />
                            </div>
                            <div class="form-group col-4 mt-2">
                                <label for="payer"> Payer </label><span class="text-danger">*</span>
                                <select class="form-select" name="payer" v-model="newTask.patientPayerId">
                                    <option :value="null">Select Payer</option>
                                    <optgroup v-for="payer in payerTypes" :key="payer.name" :label="payer.name">
                                        <option v-for="type in patientPayers" :value="type.id" :key="type.id">
                                            <template v-if="type.payerType === payer.value"> {{ type.name }} </template>
                                        </option>
                                    </optgroup>
                                </select>
                            </div>
                            <div class="form-group col-4 mt-2">
                                <label for="shift-length"> Shift Length </label>
                                <select class="form-select" v-model="shiftLength">
                                    <option value="0">Select Shift Length</option>
                                    <option v-for="i in 12" :key="i" :value="i">
                                        {{ i }} {{ i === 1 ? "Hour" : "Hours" }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group col-4 mt-2">
                                <label for="shift-time"> Shift Start Time </label>
                                <TimePicker @update-props="changeStartTime">
                                    <input
                                        type="text"
                                        class="form-control"
                                        :value="shiftStartTime"
                                        autocomplete="off"
                                        maxlength="8"
                                        :disabled="shiftLength <= 0"
                                        placeholder="Enter Shift Start Time"
                                    />
                                </TimePicker>
                            </div>
                            <div class="form-group form-check custom-checkbox col-2 mt-2 ms-3">
                                <input
                                    type="checkbox"
                                    id="on-call-visit"
                                    class="form-check-input"
                                    v-model="newTask.onCall"
                                />
                                <label class="form-check-label" for="on-call-visit"> On-Call Visit </label>
                            </div>
                        </div>
                        <section
                            class="col-10 offset-md-1 row g-0 justify-content-center"
                            v-if="taskListItems && taskListItems.id"
                        >
                            <div class="col-5 pe-2 ms-2">
                                <FrequencyCheck
                                    :visit-details="getVisitDetails"
                                    :visit-dates="newTaskStartDates"
                                    v-on:updateVisitDates="updateVisitDates"
                                    :selected-task="taskListItems"
                                    :is-outside-frequency="isOutsideFrequency"
                                    v-on:updateOutsideFrequency="updateOutsideFrequency"
                                />
                            </div>
                        </section>
                    </section>
                    <div class="d-flex justify-content-center my-2" v-if="!isLoading">
                        <template v-if="!isOutsideFrequency">
                            <button type="button" class="btn btn-primary btn-md me-2" @click="createTask('1')">
                                Save Task
                            </button>
                            <button type="button" class="btn btn-primary btn-md" @click="saveAndAddAnother('2')">
                                Save Task and Add Another
                            </button>
                        </template>
                        <template v-else>
                            <button
                                type="button"
                                class="btn btn-primary btn-md me-2"
                                @click="showFrequencyWarning(false)"
                            >
                                Save Task
                            </button>
                            <button type="button" class="btn btn-primary btn-md" @click="showFrequencyWarning(true)">
                                Save Task and Add Another
                            </button>
                        </template>
                        <span>
                            <button type="button" class="ms-2 btn btn-md btn-outline-secondary" @click="cancel()">
                                Cancel
                            </button>
                        </span>
                    </div>
                </template>
            </FormSection>
        </td>
        <td :colspan="columns" v-else class="p-3">
            <div>
                <h6 class="text-center text-warning fw-bold">
                    <i class="fas fa-exclamation-triangle"></i>
                    <span>
                        Warning: The task you are attempting to schedule is outside of the ordered visit frequency.
                    </span>
                </h6>
                <h6 class="text-center text-warning fw-bold">Do you want to continue scheduling?</h6>
                <div class="text-center">
                    <button type="button" class="btn btn-xs btn-primary" @click="createTask(saveType)">
                        Schedule Task
                    </button>
                    <button
                        type="button"
                        class="btn btn-xs btn-outline-secondary ms-2"
                        @click="closeFrequencyWarning()"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </td>
    </tr>
</template>

<script src="./HuvSfvStatusReportHosRow.ts" lang="ts"></script>
